import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()

export class SyncValidator {

  notInStringArray = (arr: string[]): any => {
    return (c: FormControl) => {
      return arr.indexOf(c.value) > -1 ? { alreadyExist: true } : null
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/validators/sync.validator.ts